import React, { useState } from "react";
import { useCallback } from "react";
import { createContext } from "react";
import { useSelector } from "react-redux";
import { findAll } from "../../services/reproductiveProtocolService";

export const REPRODUCTIVE_PROTOCOL_FORM_INITIAL_STATE = {
  id: null,
  groupId: null,
  farmId: null,
  name: null,
  duration: null,
  observations: null,
  applicationDays: [],
};

export const ReproductiveProtocolContext = createContext({
  dataList: [],
  isLoadingDataList: false,
  data: null,
  isDrawerVisible: false,
  shouldBlockToOnlyGroupUnit: false,
});

export const ReproductiveProtocolContextProvider = ({ children }) => {
  const [dataList, setDataList] = useState([]);
  const [data, setData] = useState(null);
  const [isLoadingDataList, setIsLoadingDataList] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [shouldBlockToOnlyGroupUnit, setShouldBlockToOnlyGroupUnit] =
    useState(false);

  const {
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const fetchData = useCallback(async () => {
    setIsLoadingDataList(true);
    try {
      const {
        data: { results },
      } = await findAll({ groupId, farmId });
      setDataList(results);
    } catch (error) {
    } finally {
      setIsLoadingDataList(false);
    }
  }, [farmId, groupId]);

  const openDrawer = useCallback(
    (data = null, shouldBlockToOnlyGroupUnit = false) => {
      if (data) setData(data);
      setShouldBlockToOnlyGroupUnit(shouldBlockToOnlyGroupUnit);
      setIsDrawerVisible(true);
    },
    []
  );

  const closeDrawer = useCallback(() => {
    setData(null);
    setShouldBlockToOnlyGroupUnit(false);
    setIsDrawerVisible(false);
  }, []);

  return (
    <ReproductiveProtocolContext.Provider
      value={{
        dataList,
        fetchData,
        data,
        isLoadingDataList,
        isDrawerVisible,
        openDrawer,
        closeDrawer,
        shouldBlockToOnlyGroupUnit,
      }}
    >
      {children}
    </ReproductiveProtocolContext.Provider>
  );
};
